import React, { FC, useLayoutEffect } from 'react';

import { NotificationType } from 'app/api/services/notifications/types';

import { API, useFetch } from 'app/api';
import { Spinner } from 'app/design-system/components/Spinner';
import { useTranslation } from 'app/lang';
import { Notification } from 'app/widgets/Notification';

import dictionary from './UnreadNotification.dictionary.json';

import styles from './UnreadNotification.module.scss';

type Props = {
  unreadCount?: number;
  onClick?: () => void;
};

export const UnreadNotification: FC<Props> = ({ unreadCount, onClick }) => {
  const { data, loading, makeRequest } = useFetch(
    API.notifications.getUnreadNotifications,
    { ssrUniqKey: 'notifications' },
  );
  const { t } = useTranslation();

  const notification = data?.notifications[0];

  useLayoutEffect(() => {
    if (unreadCount) {
      makeRequest({
        size: 1,
        pageNumber: 1,
      });
    }
  }, [unreadCount]);

  if (loading) {
    return (
      <Spinner size={40}
               className={styles.root} />
    );
  }

  if (!notification) {
    return (
      <div className={styles.root}>
        <span className={styles.emptyStateCaption}>
          {t(dictionary.emptyStateCaption)}
        </span>
        <h4 className={styles.emptyStateTitle}>
          {t(dictionary.emptyStateTitle)}
        </h4>
      </div>
    );
  }

  switch (notification.type) {
    case NotificationType.DEPOSIT:
    case NotificationType.WITHDRAWAL:
    case NotificationType.CASHBACK:
      return (
        <Notification className={styles.root}
                      title={notification.payload.title}
                      body={notification.payload.body}
                      type={notification.type}
                      date={new Date(notification.date)}
                      balanceChange={notification.payload.parameters.sum}
                      currency={notification.payload.parameters.currency}
                      onClick={onClick} />
      );
    default:
      return (
        <Notification className={styles.root}
                      title={notification.payload.title}
                      body={notification.payload.body}
                      type={notification.type}
                      date={new Date(notification.date)}
                      onClick={onClick} />
      );
  }
};
